import React, { useEffect, useState } from "react";
import {
  updatePlayerBankDetails,
  detelePlayerBankRecord,
} from "../../../../redux/user/actions";
import usePaginationHook from "../../../../hooks/usePaginationHook";
import { encryptData } from "../../../../utils/encryptUtils";
import { Modal, Button } from "react-bootstrap";
import { APP_CONST } from "../../../../config/const";
import BankDetailsForm from "./bankDetailsForm";
import { Toaster } from "../../../../utils/toaster";
import moment from "moment";

const BankDetails = ({ fetchInitialData, bankDetails }) => {
  const pagination = usePaginationHook({});
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedBankDetails, setSelectedBankDetails] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  // console.log("bankDetails", bankDetails);

  useEffect(() => {
    fetchInitialData();
  }, [pagination.apiParams.skip]);

  const handleModalClose = () => {
    setShowEditModal(false);
    setSelectedBankDetails({});
  };

  const updateBankDetails = async (dataToUpdate) => {
    let encryptedData = "";
    if (dataToUpdate.type === APP_CONST.PLAYER_BANK_DETAILS_TYPE.Bank) {
      encryptedData = encryptData({
        data: JSON.stringify({
          ...dataToUpdate,
          // accountNumber: parseFloat(dataToUpdate?.accountNumber),
        }),
        key: localStorage.getItem("token"),
      });
    } else {
      encryptedData = encryptData({
        data: JSON.stringify({
          ...dataToUpdate,
          cardNo: parseFloat(dataToUpdate?.cardNo),
          expiryMonth: parseFloat(dataToUpdate?.expiryMonth),
          expiryYear: parseFloat(dataToUpdate?.expiryYear),
          cvv: parseFloat(dataToUpdate?.cvv),
        }),
        key: localStorage.getItem("token"),
      });
    }
    const payload = {
      data: encryptedData,
      id: selectedBankDetails.id,
    };
    setIsLoading(true);
    const response = await updatePlayerBankDetails(payload);

    setIsLoading(false);
    handleModalClose();
    if (response?.data?.error === false) {
      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Details updated");
      fetchInitialData();
    }
  };

  const deleteBankRecord = async (record) => {
    const confirm = window.confirm("Delete record ? ");
    if (confirm) {
      const response = await detelePlayerBankRecord(record?.id);
      if (response?.data?.error === false) {
        fetchInitialData();
        Toaster(
          APP_CONST.TOAST_TYPE.SUCCESS,
          response?.data?.data?.data?.message ||
            "Bank details deleted successfully"
        );
      }
    }
  };

  return (
    <div className="">
      <div className="table-responsive mt-4">
        <h4>Account Details</h4>
        <table className="table text-white WithdrawTable">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Account Name</th>
              {/* <th scope="col">Type</th> */}
              <th scope="col">Account Number</th>
              <th scope="col">Created At</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(bankDetails.banks) &&
              bankDetails.banks.map((item, index) => {
                return (
                  <tr key={index}>
                    <th scope="row">{pagination.apiParams.skip + index + 1}</th>

                    <th style={{ cursor: "pointer" }}>{item?.name}</th>
                    {/* <td>{item?.type}</td> */}
                    <td>{item?.hint}</td>
                    <td>{moment(item?.createdAt).format("DD-MM-YY h:mm A")}</td>
                    <td>
                      <Button
                        variant="danger"
                        onClick={() => {
                          deleteBankRecord(item);
                        }}
                      >
                        Delete
                      </Button>
                      <Button
                        variant="success"
                        onClick={() => {
                          setSelectedBankDetails(item);
                          setShowEditModal(true);
                        }}
                      >
                        Update
                      </Button>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
        {/* <PaginationCard pagination={pagination} count={bankDetails?.count} /> */}
      </div>
      <Modal
        show={showEditModal}
        onHide={handleModalClose}
        className="updateBankDeatils"
      >
        <Modal.Header closeButton>
          <Modal.Title>Update bank details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <BankDetailsForm
            isLoading={isLoading}
            handleSubmit={updateBankDetails}
            isEditMode={true}
            selectedBankDetails={selectedBankDetails}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};
export default BankDetails;
